import ABC from "@akitabox/constants/dist/akitabox.constants.json";

export const constants = { ...ABC };
